import React from 'react';
import { withTranslation } from 'react-i18next';
import { OverlayTrigger } from 'react-bootstrap';
import { BsFilter } from "react-icons/bs";
import Utils from '../../../core/utilities/Utils';
import './ContentBlocksFilterStatus.scss';

const ContentBlocksFilterStatus = ({ t, filter, onFilterClick }) => {
  const getYearFromPeriod = (reportingPeriod) => {
    if (!reportingPeriod) return new Date().getFullYear();
    return new Date(reportingPeriod).getFullYear();
  };

  return (
    <div className="content-blocks-filter-status Onetime_filter">
      {/* Year Filter - Always show */}
      <span className="Filter_status">
        <h6>{t("Year.label")}: </h6>
        {getYearFromPeriod(filter.reportingPeriod)}
      </span>

      {/* Filter Icon - At the end */}
      <OverlayTrigger
        placement="top"
        overlay={Utils.renderTooltip(
          t("Filter.label")
        )}>
        <button
          className="btn btn-headbtn filter-icon"
          onClick={onFilterClick}
        >
          <BsFilter />
        </button>
      </OverlayTrigger>
    </div>
  );
};

export default withTranslation()(ContentBlocksFilterStatus);
